import PropTypes from 'prop-types';

export const FAQ_ARTICLE = {
  articleContent: PropTypes.string,
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  topicId: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
};

export const FAQ_ACTIVE_ARTICLE_CONTENT = {
  upfront_header: PropTypes.string,
  related_header: PropTypes.string,
};

export const FAQ_RELATED_ARTICLE = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  excerpt: PropTypes.string,
  rank: PropTypes.number,
};

export const RELATED_ARTICLES = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
};

// Filtered Customer Service hour
export const CUSTOMER_HOURS = {
  amPerCall: PropTypes.string,
  amTime1: PropTypes.string,
  amTime2: PropTypes.string,
  generalTime1: PropTypes.string,
  generalTime2: PropTypes.string,
  hoursOfService: PropTypes.string,
};

// Data shape of phone data filtered by `dataParser`
export const CALL_US_CONTACT_INFO = {
  amFlag: PropTypes.string,
  amPhone: PropTypes.string,
  customerHour: PropTypes.shape(CUSTOMER_HOURS),
  generalMTS: PropTypes.string,
  generalPhoneNumber: PropTypes.string,
  header: PropTypes.string,
  mobileHeader: PropTypes.string,
  logoutInst: PropTypes.string,
  mobileLogoutInst: PropTypes.string,
  mtsPhone: PropTypes.string,
  phoneNumber: PropTypes.arrayOf(PropTypes.string),
  specialInstruction: PropTypes.string,
  webPin: PropTypes.string,
};

export const CALL_US_PHONE_INFO = {
  isphonePresent: PropTypes.bool,
  phoneNumber: PropTypes.arrayOf(PropTypes.string),
  isInstructionPresent: PropTypes.bool,
  specialInstruction: PropTypes.string,
  showServiceHourHeader: PropTypes.bool,
  hoursOfService: PropTypes.string,
  webPin: PropTypes.string,
};

export const CALL_US = {
  contactInfo: PropTypes.shape(CALL_US_PHONE_INFO),
};

export const SELECT_RESULT = {
  topicId: PropTypes.string,
  topicName: PropTypes.string,
};

export const WEBFORM_FIELDS_DETAILS = {
  character_limit: PropTypes.string,
  default_text: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
};

export const WEBFORM_OTHER_FIELD_DETAILS = {
  topicId: PropTypes.string,
  kanaCode: PropTypes.string,
  topicName: PropTypes.string,
  subTopicName: PropTypes.string,
  pageflow: PropTypes.string,
};

export const WEBFORM_ERRORS = {
  required: PropTypes.string,
  limit: PropTypes.string,
};

export const SELECT_BOX_OPTIONS = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export const NOTIFIER_DETAILS_LINK_ITEM = {
  label: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.func,
};

export const NOTIFIER_DETAILS = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
};

export const ALERT = {
  messageType: PropTypes.string,
  message: PropTypes.string,
};

export const TAB = {
  key: PropTypes.string,
  label: PropTypes.string,
  priority: PropTypes.number,
  href: PropTypes.string,
};

export const TOPICTREE_SEGMENT = {
  hide_topic: PropTypes.bool,
  leaf_node: PropTypes.bool,
  ref_id: PropTypes.string,
  topic_id: PropTypes.string,
  topic_name: PropTypes.string,
};

export const TOPICTREE_SELECTION = { ...TOPICTREE_SEGMENT, sub_topics: PropTypes.array };

export const TOPICTREE_RESULT = { ...TOPICTREE_SEGMENT, web_form_id: PropTypes.string };

export const TOPICTREE = {
  display: PropTypes.bool,
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  topicTreeSelection: PropTypes.shape(TOPICTREE_SELECTION),
  topicTreeSelectionL1: PropTypes.shape(TOPICTREE_SELECTION),
  topicTreeSelectionL2: PropTypes.oneOfType([
    PropTypes.shape(TOPICTREE_RESULT),
    PropTypes.shape(TOPICTREE_SELECTION),
  ]),
  topicTreeSelectionL3: PropTypes.shape(TOPICTREE_RESULT),
};

export const TOPICLAYERS = {
  layer1: PropTypes.string,
  layer2: PropTypes.string,
  layer3: PropTypes.string,
};

export const TOPICSELECT = {
  layer: PropTypes.number,
  subTopics: PropTypes.array,
  topics: PropTypes.shape(TOPICLAYERS),
};

export const QUICKANSWERS = {
  layer1: PropTypes.array,
  layer2: PropTypes.array,
};

export const QUICKANSWERS_SELECTED = {
  layer1: PropTypes.string,
  layer2: PropTypes.string,
};

export const TOP_REASON_TOPICS = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
  channel: PropTypes.string,
  excerpt: PropTypes.string,
  rank: PropTypes.number,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  usage: PropTypes.number,
};

export const ERROR_MESSAGE = {
  message: PropTypes.string,
  tryAgain: PropTypes.string,
};

export const REF_SELECT_RESULT = {
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  topicRefId: PropTypes.string,
};

export const TOPIC_TREE_SELECT_RESULT = {
  topicTreeSelectResult: PropTypes.shape(REF_SELECT_RESULT),
  topicsDisplay: PropTypes.bool,
};

export const SUB_TOPIC = {
  hide_topic: PropTypes.bool,
  leaf_node: PropTypes.bool,
  ref_id: PropTypes.string,
  topic_id: PropTypes.string,
  topic_name: PropTypes.string,
  web_form_id: PropTypes.string,
};

export const CONTACT_OPTION = {
  type: PropTypes.string,
  priority: PropTypes.string,
};

export const CRAWL_INTENT_SEARCH_TOPIC = {
  hide_topic: PropTypes.bool,
  leaf_node: PropTypes.bool,
  parents: PropTypes.arrayOf(PropTypes.string),
  ref_id: PropTypes.string,
  topic_id: PropTypes.string,
  topic_name: PropTypes.string,
  web_form_id: PropTypes.string,
};

export const TOOLTIP_CONTENT_POSITION = {
  x: PropTypes.number,
  y: PropTypes.number,
};

export const TAB_CONTENT = {
  label: PropTypes.string,
  logo: PropTypes.string,
  content: PropTypes.element,
  priority: PropTypes.number,
  onClick: PropTypes.func,
};

export const LEXA_STATE = {
  loaded: PropTypes.bool,
  available: PropTypes.bool,
  waitTime: PropTypes.string,
};

export const RACINFO = {
  request_a_call_enabled: PropTypes.bool,
};
export const RAC = {
  loaded: PropTypes.bool,
  racInfo: PropTypes.shape(RACINFO),
};

export const AVAILABLE_DECISION = {
  availability_decision: PropTypes.string,
  name: PropTypes.string,
  rank: PropTypes.number,
};

export const DISPUTE_CASE = {
  create_time: PropTypes.string,
  dispute_amount: PropTypes.shape({
    currency_code: PropTypes.string,
    value: PropTypes.string,
  }),
  dispute_channel: PropTypes.string,
  dispute_flow: PropTypes.string,
  dispute_id: PropTypes.string,
  dispute_life_cycle_stage: PropTypes.string,
  dispute_state: PropTypes.string,
};

export const CALLUS_ELMO_TREATMENTS = {
  callUsElmoTreatments: PropTypes.string,
};
